(() => {
  if (window.tsyrkFormStatesReady) return;
  window.tsyrkFormStatesReady = true;

  function init(root = document) {
    root.querySelectorAll('.tsyrk-custom-order__form, .tsyrk-footer__form').forEach((form) => {
      if (form.dataset.tsyrkFormReady) return;
      form.dataset.tsyrkFormReady = 'true';
      form.noValidate = true;
      const controls = [...form.querySelectorAll('input:not([type="hidden"]), textarea')];

      function validate(field, show) {
        if (field.matches('[data-tsyrk-date]')) {
          const match = field.value.trim().match(/^(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})$/);
          const date = match && new Date(+match[3], +match[2] - 1, +match[1]);
          const valid = !field.value || (match && date.getFullYear() === +match[3] && date.getMonth() === +match[2] - 1 && date.getDate() === +match[1]);
          field.setCustomValidity(valid ? '' : 'Enter a valid date in DD / MM / YYYY format.');
        }
        const error = form.querySelector(`[id="${CSS.escape(field.id)}-error"]`);
        if (!error) return;
        const invalid = !field.validity.valid;
        if (show && invalid) {
          field.setAttribute('aria-invalid', 'true');
          error.textContent = field.validationMessage;
          error.hidden = false;
        } else if (!invalid) {
          field.removeAttribute('aria-invalid');
          error.hidden = true;
          error.textContent = '';
        }
      }

      controls.forEach((field) => {
        field.addEventListener('blur', () => validate(field, Boolean(field.value) || field.getAttribute('aria-invalid') === 'true'));
        field.addEventListener('input', () => {
          validate(field, field.getAttribute('aria-invalid') === 'true');
          if (field.matches('[data-tsyrk-autogrow]')) grow(field);
        });
        field.addEventListener('invalid', (event) => { event.preventDefault(); validate(field, true); });
        if (field.matches('[data-tsyrk-autogrow]')) grow(field);
      });
      form.addEventListener('submit', (event) => {
        controls.forEach((field) => validate(field, true));
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          controls.find((field) => !field.validity.valid)?.focus();
        }
        // Keep Shopify / SyncForm's native submission flow. Never simulate success.
      }, true);
    });
  }
  function grow(field) {
    field.style.height = '48px';
    field.style.height = `${Math.max(48, field.scrollHeight + 2)}px`;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('tsyrk:form-ready', (event) => init(event.detail));
})();
